import Chart from 'chart.js';
import axios from 'axios';
import { sumBy } from 'lodash';
import { chartColours, customTooltips, valueAsPercentage } from './utils';

const config = {
    type: 'pie',
    options: {
        cutoutPercentage: 62.5,
        responsive: true,
        hover: {
            mode: null,
        },
        legend: {
            display: false,
        },
        legendCallback(chart) {
            const dataset = chart.data.datasets[0];
            const total = sumBy(dataset.data, number => parseFloat(number));

            return dataset.data.map((value, index) => {
                const outputValue = dataset.percentage ? valueAsPercentage(value, total) : value;
                return `<li>
                    <span style="background-color:${dataset.backgroundColor[index]}"></span>
                    <em>${outputValue}</em>
                    ${dataset.labels[index]}
                </li>`;
            }).join('');
        },
        tooltips: {
            enabled: false,
            callbacks: {
                title(tooltipItem, data) {
                    return data.datasets[tooltipItem[0].datasetIndex].labels[tooltipItem[0].index];
                },
            },
            custom(tooltip) {
                if (tooltip.body === undefined) {
                    customTooltips({
                        tooltip,
                        chart: this,
                        hide: true,
                    });
                    return;
                }

                tooltip.body.map((bodyItem, index) => {
                    const label = bodyItem.lines[0].split(': ');

                    customTooltips({
                        tooltip,
                        chart: this,
                        value: label[1],
                        text: tooltip.title[0],
                        colour: tooltip.labelColors[index].backgroundColor,
                        hide: false,
                    });

                    return true;
                });
            },
        },
        animation: {
            onComplete() {
                this.canvas.nextElementSibling.setAttribute('src', this.toBase64Image());
            },
        },
    },
};

export default (() => {
    const charts = Array.from(document.querySelectorAll('.js-pie-chart'));

    charts.forEach((canvas) => {
        const ctx = canvas.getContext('2d');

        axios.get(`/api/chart/pie/${canvas.dataset.chart}.json`)
            .then((response) => {
                const data = {
                    datasets: [{
                        data: response.data.values,
                        labels: response.data.labels,
                        backgroundColor: Array(7).fill().map((value, index) => chartColours[index]),
                        percentage: response.data.percentage,
                    }],
                };

                const chart = new Chart(ctx, { ...config, data });
                const legend = canvas.closest('.pie-chart').querySelector('.js-pie-chart-legend');
                legend.innerHTML = chart.generateLegend();
            });
    });
})();
